import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PrivateRoute from './Entities/PrivateRoute';
import Home from './Pages/Home';
import Login from './Pages/NoUser/Login';
import Logout from './Pages/NoUser/Logout';
import ForgotPassword from './Pages/NoUser/ForgotPass';
import Register from './Pages/NoUser/Register';
import Help from './Pages/NoUser/Help';
import ProfileSettings from './Pages/Users/ProfileSettings';
import SpaceManager from './Pages/Devices/SpaceManager';
import NewSpace from './Pages/Devices/NewSpace';
import EditSpace from './Pages/Devices/EditSpace';
import NewHub from './Pages/Devices/NewHub';
import EditHub from './Pages/Devices/EditHub';
import EditPot from './Pages/Pots/EditPot';
import AdvancedPotSettings from './Pages/Pots/AdvancedPotSettigs';
import CalibrateIrrigationTime from './Pages/Pots/CalibrateIrrigationTime';
import PotDetails from './Pages/Pots/PotDetails';
import PotDetailsADMIN from './Pages/Pots/PotDetailsADMIN';
import MyCustomPlants from './Pages/CustomPlants/MyCustomPlants';
import CreateCustomPlant from './Pages/CustomPlants/CreateCustomPlant';
import EditCustomPlant from './Pages/CustomPlants/EditCustomPlant';
import PlantDetails from './Pages/Plants/PlantDetails';
import ScannPlant from './Pages/Plants/ScannPlant';
import PotManager from './Pages/Pots/PotManager';
import WifiQRScanner from './Pages/FastActions/WifiQRScanner';
import AddPlant from './Pages/Pots/AddPlant';
import AddHubFast from './Pages/FastActions/AddHubFast';
import LinkHubFast from './Pages/FastActions/LinkHubFast';
import ConfigureHubFast from './Pages/FastActions/ConfigureHubFast';
import AddPotFast from './Pages/FastActions/AddPotFast';
import ConfigurePotFast from './Pages/FastActions/ConfigurePotFast';
import FastActions from './Pages/FastActions/FastActions';

import Header from './Header';
import NoUserHeader from './NoUserHeader';
import HelpHeader from './HelpHeader';

function App() {
    return (
        <Router>
            <div>
                <HeaderSelector />
                <div>
                    <Routes>
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/forgotPassword" element={<ForgotPassword />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/users/profileSettings" element={<PrivateRoute><ProfileSettings /></PrivateRoute>} />
                        <Route path="/spaces/spaceManager" element={<PrivateRoute><SpaceManager /></PrivateRoute>} />
                        <Route path="/spaces/newSpace" element={<PrivateRoute><NewSpace /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName" element={<PrivateRoute><EditSpace /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName/newHub/" element={<PrivateRoute><NewHub /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName/editHub/:hubSN" element={<PrivateRoute><EditHub /></PrivateRoute>} />
                        <Route path="/pots/potManager" element={<PrivateRoute><PotManager /></PrivateRoute>} />
                        <Route path="/plants/:plantName/details" element={<PrivateRoute><PlantDetails /></PrivateRoute>} />
                        <Route path="plants/addToPot" element={<PrivateRoute><AddPlant /></PrivateRoute>} />
                        <Route path="plants/addToPot/scanPlant" element={<PrivateRoute><ScannPlant /></PrivateRoute>} />
                        <Route path="/customPlants" element={<PrivateRoute><MyCustomPlants /></PrivateRoute>} />
                        <Route path="/customPlants/create" element={<PrivateRoute><CreateCustomPlant /></PrivateRoute>} />
                        <Route path="/customPlants/edit/:customPlantID" element={<PrivateRoute><EditCustomPlant /></PrivateRoute>} />
                        <Route path="/pots/:potSensorDeviceMac/details" element={<PrivateRoute><PotDetails /></PrivateRoute>} />
                        <Route path="/pots/:potSensorDeviceMac/adminDetails" element={<PrivateRoute><PotDetailsADMIN /></PrivateRoute>} />
                        <Route path="/pots/potManager/editPot/:deviceID" element={<PrivateRoute><EditPot /></PrivateRoute>} />
                        <Route path="/pots/potManager/editPot/:deviceID/advancedSettings" element={<PrivateRoute><AdvancedPotSettings /></PrivateRoute>} />
                        <Route path="/pots/potManager/editPot/:deviceID/calibrateIrrigationTime" element={<PrivateRoute><CalibrateIrrigationTime /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName/editHub/:hubSN/editPot/:deviceID" element={<PrivateRoute><EditPot /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName/editHub/:hubSN/editPot/:deviceID/advancedSettings" element={<PrivateRoute><AdvancedPotSettings /></PrivateRoute>} />
                        <Route path="/spaces/editSpace/:spaceName/editHub/:hubSN/editPot/:deviceID/calibrateIrrigationTime" element={<PrivateRoute><CalibrateIrrigationTime /></PrivateRoute>} />
                        <Route path="/fastActions" element={<PrivateRoute><FastActions /></PrivateRoute>} />
                        <Route path="/fastActions/addHub" element={<PrivateRoute><AddHubFast /></PrivateRoute>} />
                        <Route path="/fastActions/addHub/qrScanner" element={<PrivateRoute><WifiQRScanner /></PrivateRoute>} />
                        <Route path="/fastActions/addHub/link" element={<PrivateRoute><LinkHubFast /></PrivateRoute>} />
                        <Route path="/fastActions/addHub/link/configure" element={<PrivateRoute><ConfigureHubFast /></PrivateRoute>} />
                        <Route path="/fastActions/addPot" element={<PrivateRoute><AddPotFast /></PrivateRoute>} />
                        <Route path="/fastActions/addPot/configure" element={<PrivateRoute><ConfigurePotFast /></PrivateRoute>} />
                        <Route path="/fastActions/addPot/configure/advancedSettings" element={<PrivateRoute><AdvancedPotSettings /></PrivateRoute>} />
                        <Route path="/fastActions/addPot/configure/calibrateIrrigationTime" element={<PrivateRoute><CalibrateIrrigationTime /></PrivateRoute>} />
                    </Routes>
                </div>
            </div>
        </Router>
    );
}

function HeaderSelector() {
    const location = useLocation();
    const noAuthPaths = ['/login', '/register', '/forgotPassword'];
    const helpPath = '/help';

    if (noAuthPaths.includes(location.pathname)) {
        return <NoUserHeader />;
    }

    if (location.pathname === helpPath) {
        return <HelpHeader />;
    }

    return <Header />;
}

export default App;
